<template>
    <div>
        <Sidebar></Sidebar>

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-create d-lg-inline-block"></div>
            <Header></Header>

            <section class="content">
                <div class="container-fluid">
                    <div class="row" v-if="loading">
                        <div class="col-md-9">
                            <p>Chargement...</p>
                        </div>
                    </div>

                    <div class="row" v-else-if="exemption">
                        <div class="col-md-9 form-request-content">
                            <div class="request-title">
                                <h1>Modifier la demande de dispense</h1>
                            </div>

                            <!-- Infos non modifiables -->
                            <div class="exemption-details">
                                <div class="row" v-for="(value, label) in readOnlyDetails" :key="label">
                                    <div class="col col-md-4 label">{{ label }}</div>
                                    <div class="col">{{ value }}</div>
                                </div>
                            </div>

                            <!-- Champs modifiables -->
                            <h3 class="title-content">Informations modifiables</h3>
                            <div class="form-group">
                                <form novalidate="novalidate" class="needs-validation">

                                    <!-- Civilité -->
                                    <div class="form-group">
                                        <label for="update_civility">Civilité</label>
                                        <select
                                            id="update_civility"
                                            class="form-control"
                                            v-model="form.civility"
                                        >
                                            <option value="">-- Choisir --</option>
                                            <option
                                                v-for="civility in civilities"
                                                :key="civility.id"
                                                :value="civility.label"
                                            >{{ civility.label }}</option>
                                        </select>
                                    </div>

                                    <!-- Prénom -->
                                    <div class="form-group">
                                        <label for="update_firstName">Prénom</label>
                                        <input
                                            type="text"
                                            id="update_firstName"
                                            class="form-control form-control-lg"
                                            v-model="form.firstName"
                                        >
                                    </div>

                                    <!-- Nom -->
                                    <div class="form-group">
                                        <label for="update_lastName">Nom</label>
                                        <input
                                            type="text"
                                            id="update_lastName"
                                            class="form-control form-control-lg"
                                            v-model="form.lastName"
                                        >
                                    </div>

                                    <!-- Nom de naissance -->
                                    <div class="form-group">
                                        <label for="update_birthName">Nom de naissance</label>
                                        <input
                                            type="text"
                                            id="update_birthName"
                                            class="form-control form-control-lg"
                                            v-model="form.birthName"
                                        >
                                    </div>

                                    <!-- Date de naissance -->
                                    <div class="form-group">
                                        <label for="update_birthDate">Date de naissance</label>
                                        <input
                                            type="date"
                                            id="update_birthDate"
                                            class="form-control form-control-lg"
                                            v-model="form.birthDate"
                                        >
                                    </div>

                                    <!-- Email -->
                                    <div class="form-group">
                                        <label for="update_email">Email professionnel</label>
                                        <input
                                            type="email"
                                            id="update_email"
                                            class="form-control form-control-lg"
                                            v-model="form.email"
                                        >
                                    </div>

                                    <!-- Téléphone -->
                                    <div class="form-group">
                                        <label for="update_phoneNumber">Téléphone</label>
                                        <input
                                            type="text"
                                            id="update_phoneNumber"
                                            class="form-control form-control-lg"
                                            v-model="form.phoneNumber"
                                        >
                                    </div>

                                    <!-- Date d'embauche -->
                                    <div class="form-group" v-if="settings.employmentDateHandled">
                                        <label for="update_employmentDate">Date d'embauche</label>
                                        <input
                                            type="date"
                                            id="update_employmentDate"
                                            class="form-control form-control-lg"
                                            v-model="form.employmentDate"
                                        >
                                    </div>

                                    <!-- Date limite (modifiable uniquement en to_finalise) -->
                                    <div class="form-group" v-if="exemption && exemption.status === 'to_finalise'">
                                        <label for="update_deadlineDate">Date limite</label>
                                        <input
                                            type="date"
                                            id="update_deadlineDate"
                                            class="form-control form-control-lg"
                                            :min="minDeadlineDate"
                                            :max="maxDeadlineDate"
                                            v-model="form.deadlineDate"
                                        >
                                    </div>

                                    <!-- Matricule (conditionnel) -->
                                    <div class="form-group" v-if="settings.employeeNumberHandled">
                                        <label for="update_employeeNumber">Matricule</label>
                                        <input
                                            type="text"
                                            id="update_employeeNumber"
                                            class="form-control form-control-lg"
                                            v-model="form.employeeNumber"
                                        >
                                    </div>

                                    <!-- Type de contrat (conditionnel) -->
                                    <div class="form-group" v-if="settings.contractTypeHandled !== false">
                                        <label for="update_contractTypeId">Type de contrat</label>
                                        <select
                                            id="update_contractTypeId"
                                            class="form-control"
                                            v-model="form.contractTypeId"
                                        >
                                            <option :value="null">—</option>
                                            <option
                                                v-for="ct in contractTypes"
                                                :key="ct.id"
                                                :value="ct.id"
                                            >{{ ct.title }}</option>
                                        </select>
                                    </div>

                                    <!-- Entreprise -->
                                    <div class="form-group">
                                        <label for="update_enterpriseId">Entreprise</label>
                                        <select
                                            id="update_enterpriseId"
                                            class="form-control select2"
                                            v-model="form.enterpriseId"
                                        >
                                            <option v-for="(name, id) in enterprises" :key="id" :value="Number(id)">{{ name }}</option>
                                        </select>
                                    </div>

                                </form>
                            </div>
                        </div>

                        <div class="col-md-3 col-xl-3"></div>

                        <div class="input-group col-md-9 mx-sm-auto my-md-4">
                            <button
                                class="btn btn-secondary btn-lg mr-2"
                                @click.prevent="goBack"
                            >Retour</button>
                            <button
                                class="btn btn-success btn-lg"
                                :disabled="submitting"
                                @click.prevent="save"
                            >
                                <span>Enregistrer les modifications</span>
                                <span
                                    v-if="submitting"
                                    class="spinner-border spinner-border-sm ml-2"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import moment from 'moment';

    import Sidebar from '../../components/Sidebar';
    import Footer from '../../components/Footer';
    import Header from '../../components/Header';
    import { fetchContactTypes, fetchExemptionById, patchExemptionPersonalData } from '../../service/api/exemptions.api';
    import { fetchEnterprisesIdAndNames } from '../../service/api/enterprise.api';
    import { getExemptionStatusLabel } from '../../utils/utils';

    export default {
        data() {
            return {
                exemption: null,
                loading: true,
                submitting: false,
                enterprises: {},
                settings: {},
                form: {
                    civility: '',
                    firstName: '',
                    lastName: '',
                    birthName: '',
                    birthDate: '',
                    email: '',
                    phoneNumber: '',
                    employmentDate: '',
                    deadlineDate: '',
                    employeeNumber: '',
                    contractTypeId: null,
                    enterpriseId: null,
                },
            };
        },
        computed: {
            ...mapGetters({
                contractTypes: 'contractTypes',
                civilities: 'civilities',
                enterpriseSettings: 'enterpriseSettings',
            }),
            readOnlyDetails() {
                if (!this.exemption) {
                    return {};
                }

                const details = {
                    'État': getExemptionStatusLabel(this.exemption.status),
                    'Date de création': this.exemption.createdAt ? moment(this.exemption.createdAt).format('DD/MM/YYYY') : '',
                    'Date de début': this.exemption.startDate ? moment(this.exemption.startDate).format('DD/MM/YYYY') : '',
                    'Date de fin': this.exemption.exemptionReason?.expirationDate ? moment(this.exemption.exemptionReason.expirationDate).format('DD/MM/YYYY') : '',
                    'Motif': this.exemption.exemptionReason?.reason?.titleHro ?? '',
                };

                if (this.exemption.status !== 'to_finalise') {
                    details['Date limite'] = this.exemption.deadlineDate ? moment(this.exemption.deadlineDate).format('DD/MM/YYYY') : '';
                }

                return details;
            },
            minDeadlineDate() {
                return moment().add(1, 'days').format('YYYY-MM-DD');
            },
            maxDeadlineDate() {
                return moment().add(2, 'months').format('YYYY-MM-DD');
            },
        },
        async mounted() {
            await this.loadData();
        },
        methods: {
            ...mapActions({
                setSettingsContext: 'setSettingsContext',
                fetchCivilities: 'fetchCivilities',
            }),
            async loadData() {
                this.loading = true;
                try {
                    const { data } = await fetchExemptionById(this.$route.params.exemptionId);
                    this.exemption = data;

                    await this.setSettingsContext({ enterpriseUuid: data.enterprise.uuid });
                    this.settings = this.enterpriseSettings || {};

                    const [entData] = await Promise.all([
                        fetchEnterprisesIdAndNames(),
                        fetchContactTypes(),
                        this.fetchCivilities(),
                    ]);

                    this.enterprises = entData.data.reduce((acc, { id, name }) => ({ ...acc, [id]: name }), {});

                    this.form = {
                        civility: data.civility ?? '',
                        firstName: data.firstName ?? '',
                        lastName: data.lastName ?? '',
                        birthName: data.birthName ?? '',
                        birthDate: data.birthDate ? moment(data.birthDate).format('YYYY-MM-DD') : '',
                        email: data.email ?? '',
                        phoneNumber: data.phoneNumber ?? '',
                        employmentDate: data.employmentDate ? moment(data.employmentDate).format('YYYY-MM-DD') : '',
                        deadlineDate: data.deadlineDate ? moment(data.deadlineDate).format('YYYY-MM-DD') : '',
                        employeeNumber: data.employeeNumber ?? '',
                        contractTypeId: data.contractType?.id ?? null,
                        enterpriseId: data.enterprise?.id ?? null,
                    };
                } finally {
                    this.loading = false;
                }
            },
            async save() {
                this.submitting = true;
                try {
                    const payload = {
                        civility: this.form.civility,
                        firstName: this.form.firstName,
                        lastName: this.form.lastName,
                        birthName: this.form.birthName,
                        birthDate: this.form.birthDate,
                        email: this.form.email,
                        phoneNumber: this.form.phoneNumber,
                        ...(this.settings.employmentDateHandled && { employmentDate: this.form.employmentDate }),
                        enterpriseId: this.form.enterpriseId,
                    };

                    if (this.exemption.status === 'to_finalise') {
                        payload.deadlineDate = this.form.deadlineDate;
                    }
                    if (this.settings.employeeNumberHandled) {
                        payload.employeeNumber = this.form.employeeNumber;
                    }
                    if (this.settings.contractTypeHandled !== false) {
                        payload.contractTypeId = this.form.contractTypeId;
                    }

                    await patchExemptionPersonalData(this.$route.params.exemptionId, payload);

                    this.$swal({
                        icon: 'success',
                        title: 'Modifications enregistrées',
                        timer: 2000,
                        showConfirmButton: false,
                    });

                    await this.$router.push({ name: 'exemption-search' });
                } catch (error) {
                    const data = error.response?.data;
                    const message = data?.violations?.map(v => v.title ?? v.detail).join('<br>')
                        ?? data?.detail
                        ?? 'Une erreur est survenue. Veuillez réessayer.';

                    this.$swal({
                        icon: 'error',
                        html: message,
                        timer: 15000,
                        timerProgressBar: true,
                        showConfirmButton: true,
                        confirmButtonText: 'Fermer',
                    });
                } finally {
                    this.submitting = false;
                }
            },
            goBack() {
                this.$router.back();
            },
        },
        components: {
            Header,
            Sidebar,
            Footer,
        },
    }
</script>

<style scoped lang="scss">
    .exemption-details {
        margin: 20px 0 30px;

        .row {
            min-height: 24px;
            margin: 4px 0;
            background: #f9fafc;
        }

        .label {
            font-size: 14px;
            font-weight: 700;
        }
    }
</style>
